import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './login/logout.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { SplendidCRMDFService } from './services/SplendidCRMDFService';
import { AuthGuard } from './services/AuthGuardService.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TabsModule } from 'ngx-bootstrap';



export const routes: Routes = [
  {
    path: '',
    redirectTo: '/calendario',
    pathMatch: 'full',
    canActivate:[ AuthGuard ]
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: '',
    component: FullLayoutComponent,
    canActivate: [ AuthGuard ],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'visitas',
        loadChildren: './operacion/visitas/visitas.module#VisitasModule'
      },
      {
        path: 'promociones',
        loadChildren: './operacion/promociones/promociones.module#PromocionesModule'
      },
      {
        path:'reuniones',
        loadChildren: './operacion/reuniones/reuniones.module#ReunionesModule'
      },
      {
        path: 'minoristas',
        loadChildren: './operacion/minoristas/minoristas.module#MinoristasModule'
      },
       {
        path: 'catalogo',
        loadChildren: './catalogo/catalogo.module#CatalogoModule'
      },
      {
        path: 'calendario',
        loadChildren: './operacion/calendario/calendario.module#CalendarioModule'
      },
      {
        path: 'segmentos',
        loadChildren: './operacion/segmento-vertical/segmentovertical.module#SegmentoVerticalModule'
      },
      {
        path: 'generales',
        loadChildren: './operacion/generales/generales.module#GeneralesModule'
      },
      {
        path: 'prospectos',
        loadChildren: './operacion/contactos/contactos-seguimiento.module#ContactosSeguimientoModule'
      },
      {
        path:'homedepot',
        loadChildren: './homedepot/homedepot.module#HomeDepotModule'
      },
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes), FormsModule, ReactiveFormsModule, SimpleNotificationsModule,
    NgxSpinnerModule, TabsModule.forRoot() ],
  exports: [ RouterModule ],
  declarations: [
    LoginComponent, LogoutComponent
  ],
  providers:[AuthGuard]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /app/src/app/app.routing.ts